export default {
  // Backend
  backendTrainingSchedules (state) {
    return state.trainingSchedules.filter(item => item.lang === 'vn')
  },
  backendTrainingScheduleDetails (state) {
    return state.trainingScheduleDetails.filter(item => item.lang === 'vn').slice().reverse()
  },
  enBackendScheduleTab: (state) => (url) => {
    const data = state.trainingSchedules.find(item => item.url === url && item.lang === 'en')
    if (!data) {
      return state.blankScheduleData
    }
    return data
  },
  enBackendScheduleDetailTab: (state) => (url) => {
    const data = state.trainingScheduleDetails.find(item => item.url === url && item.lang === 'en')
    if (!data) {
      return state.blankScheduleData
    }
    return data
  },
  selectTrainingSchedules: (state) => (lang) => {
    const data = state.trainingSchedules
      .filter(item => item.lang === lang)
      .map(item => ({ id: item.id, name: item.name, url: item.url }))
    return data
  },
  showTrainingSchedules: (state) => (id) => {
    const data = state.trainingSchedules
      .find(item => item.id === id)
    return data.name
  },
  //
  finalLibNoti (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.libNoti[0]
    } else {
      return state.libNoti[1]
    }
  },
  finalTrainingSchedule (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnTrainingSchedule
    } else {
      return state.enTrainingSchedule
    }
  },
  finalClassLayout (state) {
    return state.layout
  },
  finalEvaluation1 (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnEvaluation[0]
    } else {
      return state.enEvaluation[0]
    }
  },
  finalEvaluation2 (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.vnEvaluation[1]
    } else {
      return state.enEvaluation[1]
    }
  },
  // Training Schedules
  finalTrainingSchedules (state, getters, rootState) {
    if (rootState.lang === 'vn') {
      return state.trainingSchedules.filter(item => item.lang === 'vn')
    } else {
      return state.trainingSchedules.filter(item => item.lang === 'en')
    }
  },
  filterTrainingScheduleDetails: (state, getters, rootState) => (id) => {
    if (rootState.lang === 'vn') {
      const data = state.trainingScheduleDetails.filter(item => item.lang === 'vn')
      return data.filter(item => item.trainingScheduleId === id)
    } else {
      const data = state.trainingScheduleDetails.filter(item => item.lang === 'en')
      return data.filter(item => item.trainingScheduleId === id)
    }
  },
  findTrainingScheduleDetails: (state, getters, rootState) => (url) => {
    if (rootState.lang === 'vn') {
      const data = state.trainingScheduleDetails.filter(item => item.lang === 'vn')
      return data.find(item => item.url === url)
    } else {
      const data = state.trainingScheduleDetails.filter(item => item.lang === 'en')
      return data.find(item => item.url === url)
    }
  },
  findTrainingSchedule: (state, getters, rootState) => (trainingScheduleId) => {
    if (rootState.lang === 'vn') {
      const data = state.trainingSchedules.filter(item => item.lang === 'vn')
      return data.find(item => item.id === trainingScheduleId)
    } else {
      const data = state.trainingSchedules.filter(item => item.lang === 'en')
      return data.find(item => item.id === trainingScheduleId)
    }
  }
}
